export default "__VITE_ASSET__Cw2z3m1E__"